module.exports = __webpack_public_path__ + "static/media/id-verifing.b5453a0f.jpg";